import { isPlatformBrowser } from '@angular/common';
import { Component, HostListener } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { SuscripcionService } from 'src/app/shared/services/suscripcion.service';

@Component({
  selector: 'app-market',
  templateUrl: './market.component.html',
  styleUrls: ['./market.component.scss'],
})
export class MarketComponent {
  esSuscriptor: boolean = true;
  constructor(
    private suscripcionService: SuscripcionService,
    private keycloakService: KeycloakService,
  ) {}
  ngOnInit() {
    this.suscripcionService.isSuscriptor().subscribe(result => {
      this.esSuscriptor = result;
    });
  }
  empresas = [
    {
      tipoEmpresa: 'Hasta 1M USD',
      precio: 90,
      infoAdicional: 'Empresa con facturación anual hasta 1M USD',
    },
    {
      tipoEmpresa: 'Entre 1M y 5M USD',
      precio: 180,
      infoAdicional: 'Empresa con facturación anual entre 1M y 5M USD',
    },
    {
      tipoEmpresa: 'Más de 5M USD',
      precio: 270,
      infoAdicional: 'Empresa con facturación anual superior a 5M USD',
    },
  ];
  comunidades = [
    {
      tipoComunidad: 'Hasta 100 miembros',
      precio: '1000',
      infoAdicional: 'Comunidad con hasta 100 miembros',
    },
    {
      tipoComunidad: 'Entre 100 y 200 miembros',
      precio: '2000',
      infoAdicional: 'Comunidad con entre 100 y 200 miembros',
    },
    {
      tipoComunidad: 'Más de 200 miembros',
      precio: '3000',
      infoAdicional: 'Comunidad con más de 200 miembros',
    },
  ];
  getPopoverTriggers(): string {
    return this.isMobile() ? 'click' : 'mouseenter:mouseleave click';
  }

  private isMobile(): boolean {
    if (isPlatformBrowser(window)) {
      return window.innerWidth < 768;
    }
    return false;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {}
}
